// bus实例
import Vue from "vue";
export default new Vue();
